import { render, staticRenderFns } from "./jxs-select-modal.vue?vue&type=template&id=482ef4df&scoped=true&"
import script from "./jxs-select-modal.vue?vue&type=script&lang=js&"
export * from "./jxs-select-modal.vue?vue&type=script&lang=js&"
import style0 from "./jxs-select-modal.vue?vue&type=style&index=0&id=482ef4df&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482ef4df",
  null
  
)

export default component.exports